import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserI } from 'src/app/interfaces/user.interface';
import { ApiSdkService } from 'src/app/services/api-sdk.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-select-plan',
  templateUrl: './select-plan.page.html',
  styleUrls: ['./select-plan.page.scss'],
})
export class SelectPlanPage implements OnInit {

  userData: UserI = null as any;

  constructor(
    private router: Router,
    private apiSdkService: ApiSdkService,
    private mixpanel: MixpanelService,
    private translate: TranslateService
  ) { }

  pricingCardsEs: any[] = [
    {
      title: 'free',
      showingTitle: 'Gratis',
      price: '0',
      id: 'free',
      features: [
        { id: 'projectSize', text: 'Para probar el programa' },
        { id: 'performance', text: 'Buen rendimiento' },
        { id: 'integrations', text: 'Integraciones limitadas' },
        { id: 'users', text: '2 usuarios incluidos' },
        { id: 'storage', text: '1GB de espacio' },
        { id: 'api', text: 'Uso de la API' },
        { id: 'ai', text: 'Totalum AI' },
        { id: 'tutorials', text: 'Tutoriales interactivos' },
        { id: 'support', text: 'Soporte por e-mail' },
        { id: 'limit', text: 'Límite de 100 elementos de cada tipo (ej. 100 clientes, productos, etc)' },
        { id: 'scan', text: '35 llamadas al API scan documents' }
      ]
    },
    {
      title: 'basic',
      showingTitle: 'Básico',
      price: '49.95',
      id: 'shared',
      features: [
        { id: 'previous1', text: 'Todo lo del plan gratis'},
        { id: 'projectSize', text: 'Para empresas/proyectos pequeños' },
        { id: 'users', text: '5 usuarios incluidos' },
        { id: 'storage', text: '15GB de espacio' },
        { id: 'banking', text: 'Integración bancaria' },
        { id: 'limit', text: 'Límite de 10.000 elementos de cada tipo (ej. 10.000 clientes, productos, etc)' },
        { id: 'scan', text: '1200 llamadas al API scan documents' }
      ]
    },
    {
      title: 'professional',
      showingTitle: 'Profesional',
      price: '149.95',
      id: 'profesional',
      features: [
        { id: 'previous2', text: 'Todo lo del plan básico'},
        { id: 'projectSize', text: 'Para empresas/proyectos medianos' },
        { id: 'performance', text: 'Alto rendimiento' },
        { id: 'integrations', text: 'Integraciones ilimitadas' },
        { id: 'users', text: '15 usuarios incluidos' },
        { id: 'storage', text: '50GB de espacio' },
        { id: 'support', text: 'Soporte por e-mail y teléfono' },
        { id: 'limit', text: 'Límite de 150.000 elementos de cada tipo (ej. 150.000 clientes, productos, etc)' },
        { id: 'scan', text: '5000 llamadas al API scan documents' }
      ]
    },
    {
      title: 'enterprise',
      showingTitle: 'Empresarial',
      price: '299.95',
      id: 'enterprise',
      features: [
        { id: 'previous4', text: 'Todo lo del plan profesional'},
        { id: 'projectSize', text: 'Para empresas/proyectos grandes' },
        { id: 'performance', text: 'Alto rendimiento' },
        { id: 'users', text: '+75 usuarios'},
        { id: 'storage', text: '300GB de espacio'},
        { id: 'support', text: 'Soporte prioritario por e-mail y teléfono'},
        { id: 'limit', text: '+500.000 elementos de cada tipo' },
        { id: 'scan', text: '+8000 llamadas al API scan documents' }
      ]
    }
  ];

  pricingCardsEn = [
  {
    "title": "free",
    "showingTitle": "Free",
    "price": "0",
    "id": "free",
    "features": [
      { "id": "projectSize", "text": "For testing the program" },
      { "id": "performance", "text": "Good performance" },
      { "id": "integrations", "text": "Limited integrations" },
      { "id": "users", "text": "2 users included" },
      { "id": "storage", "text": "1GB of storage" },
      { "id": "api", "text": "API usage" },
      { "id": "ai", "text": "Totalum AI" },
      { "id": "tutorials", "text": "Interactive tutorials" },
      { "id": "support", "text": "Email support" },
      { "id": "limit", "text": "Limit of 100 items per type (e.g. 100 clients, products, etc.)" },
      { "id": "scan", "text": "35 scan documents API calls" }
    ]
  },
  {
    "title": "basic",
    "showingTitle": "Basic",
    "price": "49.95",
    "id": "shared",
    "features": [
      { "id": "previous1", "text": "Everything in the free plan" },
      { "id": "projectSize", "text": "For small companies/projects" },
      { "id": "users", "text": "5 users included" },
      { "id": "storage", "text": "15GB of storage" },
      { "id": "banking", "text": "Banking integration" },
      { "id": "limit", "text": "Limit of 10,000 items per type (e.g. 10,000 clients, products, etc.)" },
      { "id": "scan", "text": "1200 scan documents API calls" }
    ]
  },
  {
    "title": "professional",
    "showingTitle": "Professional",
    "price": "149.95",
    "id": "profesional",
    "features": [
      { "id": "previous2", "text": "Everything in the basic plan" },
      { "id": "projectSize", "text": "For medium-sized companies/projects" },
      { "id": "performance", "text": "High performance" },
      { "id": "integrations", "text": "Unlimited integrations" },
      { "id": "users", "text": "15 users included" },
      { "id": "storage", "text": "50GB of storage" },
      { "id": "support", "text": "Email and phone support" },
      { "id": "limit", "text": "Limit of 150,000 items per type (e.g. 150,000 clients, products, etc.)" },
      { "id": "scan", "text": "5000 scan documents API calls" }
    ]
  },
  {
    "title": "enterprise",
    "showingTitle": "Enterprise",
    "price": "299.95",
    "id": "enterprise",
    "features": [
      { "id": "previous4", "text": "Everything in the professional plan" },
      { "id": "projectSize", "text": "For large companies/projects" },
      { "id": "performance", "text": "High performance" },
      { "id": "users", "text": "75+ users" },
      { "id": "storage", "text": "300GB of storage" },
      { "id": "support", "text": "Priority email and phone support" },
      { "id": "limit", "text": "500,000+ items per type" },
      { "id": "scan", "text": "8000+ scan documents API calls" }
    ]
  }
]

  pricingCards: any[] = this.pricingCardsEn;


  
  async ngOnInit() {
    //get current language selected, if is not spanish, use english pricing cards, get it from angular translate service
    const currentLang = this.translate.currentLang;
    if (currentLang !== 'es') {
      this.pricingCards = this.pricingCardsEn;
    }

    //subscribe to language changes
    this.translate.onLangChange.subscribe((event) => {
      if (event.lang === 'es') {
        this.pricingCards = this.pricingCardsEs;
      } else {
        this.pricingCards = this.pricingCardsEn;
      }
    });

    await this.getUserData();
    
    this.mixpanel.createTracking({
      type: 'visit_page',
      place: 'Select plan',
    });

  }

  async getUserData() {
    const result = await this.apiSdkService.getFullUserData(true);
    this.userData = result?.success?.data;
  }


  selectPlan(plan: any) {
    if (plan.title === 'free') {
      alert('No puedes seleccionar un plan Free')
      return;
    }
    this.router.navigate(['/plan-selected'], { queryParams: { plan: plan } });

  }
}
